import types from "./types";
import service from "./service";

const list = (page = 1, filters = null) => dispatch => {
    dispatch({ type: types.LIST_NON_SODES });
    return service
        .list(page, filters)
        .then(response => {
            dispatch(listNonSodesSuccess(response));
            return Promise.resolve(response);
        })
        .catch(error => {
            dispatch(listNonSodesFail(error));
            return Promise.reject(error);
        });
};

const create = non_sode => dispatch => {
    dispatch({ type: types.CREATE_NON_SODE });
    return service
        .create(non_sode)
        .then(response => {
            dispatch(createNonSodeSuccess(response));
            return Promise.resolve(response);
        })
        .catch(error => {
            dispatch(createNonSodeFail(error));
            return Promise.reject(error);
        });
};

const getById = id => dispatch => {
    dispatch({ type: types.GET_NON_SODE_BYID });
    return service
        .getById(id)
        .then(response => {
            dispatch(getNonSodeByidSuccess(response));
            return Promise.resolve(response);
        })
        .catch(error => {
            dispatch(getNonSodeByidFail(error));
            return Promise.reject(error);
        });
};

// const update = (id, master_data) => dispatch => {
//     dispatch({ type: types.UPDATE_NON_SODE });
//     return service
//         .update(id, master_data)
//         .then(response => {
//             dispatch(updateSuccess(response));
//             return Promise.resolve(response);
//         })
//         .catch(error => {
//             dispatch(updateFail(error));
//             return Promise.reject(error);
//         });
// };
// const partialUpdate = (id, master_data) => dispatch => {
//     dispatch({ type: types.PARTIAL_UPDATE_NON_SODE });
//     return service
//         .partialUpdate(id, master_data)
//         .then(response => {
//             dispatch(partialUpdateNonSodeSuccess(response));
//             return Promise.resolve(response);
//         })
//         .catch(error => {
//             dispatch(partialUpdateNonSodeFail(error));
//             return Promise.reject(error);
//         });
// };
// const deleteById = id => dispatch => {
//     dispatch({ type: types.DELETE_NON_SODE_BYID });
//     return service
//         .deleteById(id)
//         .then(response => {
//             dispatch(deleteNonSodeByidSuccess(response));
//             return Promise.resolve(response);
//         })
//         .catch(error => {
//             dispatch(deleteNonSodeByidFail(error));
//             return Promise.reject(error);
//         });
// };
//
// const deleteNonSodeByidFail = error => ({
//     type: types.DELETE_NON_SODE_BYID_FAIL,
//     error
// });
//
// const deleteNonSodeByidSuccess = response => ({
//     type: types.DELETE_NON_SODE_BYID_SUCCESS,
//     pyload: response
// });
//
// const partialUpdateNonSodeFail = error => ({
//     type: types.PARTIAL_UPDATE_NON_SODE_FAIL,
//     error
// });
//
// const partialUpdateNonSodeSuccess = response => ({
//     type: types.PARTIAL_UPDATE_NON_SODE_SUCCESS,
//     pyload: response
// });
//
// const updateFail = error => ({
//     type: types.UPDATE_NON_SODE_FAIL,
//     error
// });
//
// const updateSuccess = response => ({
//     type: types.UPDATE_NON_SODE_SUCCESS,
//     payload: response
// });

const getNonSodeByidFail = error => ({
    type: types.GET_NON_SODE_BYID_FAIL,
    error
});

const getNonSodeByidSuccess = response => ({
    type: types.GET_NON_SODE_BYID_SUCCESS,
    payload: response
});

const createNonSodeFail = error => ({
    type: types.CREATE_NON_SODE_FAIL,
    error
});

const createNonSodeSuccess = response => ({
    type: types.CREATE_NON_SODE_SUCCESS,
    payload: response
});

const listNonSodesFail = error => ({
    type: types.LIST_NON_SODES_FAIL,
    error
});

const listNonSodesSuccess = response => {
    return {
        type: types.LIST_NON_SODES_SUCCESS,
        payload: response
    };
};

export default {
    list,
    create,
    getById
    // update,
    // partialUpdate,
    // deleteById
};
